import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Role, User } from 'app/models/user.model';
import { auth } from 'firebase';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthErrorService } from './auth-error.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public user$: Observable<User>;

  constructor(
    private firebaseAuth: AngularFireAuth, 
    private firestore: AngularFirestore,
    private authErrorService: AuthErrorService) { 
    // super();
    this.user$ = this.firebaseAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          return this.firestore.doc<User>(`users/${user.uid}`).valueChanges();
        }
        return of(null);
      })
    );
   }

  async register(email: string, password: string, role: Role): Promise<User> {
    try {
      const { user } = await this.firebaseAuth.createUserWithEmailAndPassword(email, password);
      let newUser: User = user;
      newUser.role = role;
      this.updateUserData(newUser);
      await this.sendVerificationEmail();
      return user;
    } catch (error) {
      // console.error('error al registrar! -> ', error);
      this.authErrorService.showSignupErrorAlert(error);
      return error
    }
  }

  async sendVerificationEmail(): Promise<void> {
    return (await this.firebaseAuth.currentUser).sendEmailVerification();
  }

  async login(email: string, password: string): Promise<User> {
    try {
      const { user } = await this.firebaseAuth.signInWithEmailAndPassword(
        email,
        password
      );
      console.log('user logged', user);
      // console.log('token', );
      sessionStorage.setItem('userIdToken', JSON.stringify(await user.getIdToken()));
      await this.setUserInSessionStorage(user);
      this.updateUserEmailStatus(user);
      return user;
    } catch (error) {
      console.log(error);
      this.authErrorService.showLoginErrorAlert(error);
    }
  }
  loginFacebookUser() {
    // return this.afsAuth.auth.signInWithPopup(new auth.FacebookAuthProvider())
    //   .then(credential => this.updateUserData(credential.user))
  }

  loginGoogleUser() {
    // return this.afsAuth.auth.signInWithPopup(new auth.GoogleAuthProvider())
    //   .then(credential => this.updateUserData(credential.user))
  }

  async logout(): Promise<void> {
    try {
      this.deleteUserInSessionStorage();
      await this.firebaseAuth.signOut();
    } catch (error) {
      console.log(error);
    }
  }

  isAuth() {
    // return this.afsAuth.authState.pipe(map(auth => auth));
  }

  public updateUserData(user: User) {
    const userRef: AngularFirestoreDocument<User> = this.firestore.doc(
      `users/${user.uid}`
    );
    const data: User = {
      uid: user.uid,
      email: user.email,
      emailVerified: user.emailVerified,
      // displayName: user.displayName? user.displayName : '',
      photoURL: user.photoURL,
      role: user.role,
      databaseId: user.databaseId? user.databaseId: null
    };

    return userRef.set(data);
  }

  private updateUserEmailStatus(user: User){
    const userRef: AngularFirestoreDocument<User> = this.firestore.doc(
      `users/${user.uid}`
    );
    const data: User = {
      emailVerified: user.emailVerified
    }
    return userRef.update(data);
  }

  isUserAdmin(userUid) {
    // return this.afs.doc<UserInterface>(`users/${userUid}`).valueChanges();
  }

  public async setUserInSessionStorage(user: User){
    console.log('setting user in session storage')
    try {
      // let loggedUser = await this.firestore.doc<User>(`users/${user.uid}`).get();
      let loggedUser = await (await this.firestore.collection('users').doc(user.uid).get().toPromise()).data();
      sessionStorage.setItem('loggedUser', JSON.stringify(loggedUser));
    } catch (error) {
      console.error('error setting user in session storage', error);
      return error
    }
    
    // loggedUser.subscribe(result => {
    //   console.log('prueba -> ');
    //   sessionStorage.setItem('loggedUser', JSON.stringify(result));
    // });
  }

  public deleteUserInSessionStorage(){
    sessionStorage.removeItem('loggedUser');
  }

  public getUserInfo(uid){
    return this.firestore.doc<User>(`users/${uid}`).valueChanges();
  }

  public async forgotPassword(email: string) {
    try {
      return await this.firebaseAuth.sendPasswordResetEmail(email)
      .then(() => console.log('sent Password Reset Email!'));
    } catch (error) {
      console.log(error)
      // this.authErrorService.forgotPasswordErrors(error);
    }
  }

}
